import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row flex-wrap items-start w-full gap-4" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "flex flex-column flex-wrap divide-y" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_container = _resolveComponent("el-container")!
  const _component_acl_layout = _resolveComponent("acl-layout")!

  return (_openBlock(), _createBlock(_component_acl_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (group, groupKey) => {
              return (_openBlock(), _createElementBlock("div", {
                key: groupKey,
                class: "flex-initial bg-white shadow-md w-full sm:w-4/6 md:w-3/6 lg:w-2/6 rounded-lg overflow-hidden"
              }, [
                _createElementVNode("div", {
                  class: "font-bold text-gray-600 px-4 py-4 border-b-2",
                  textContent: _toDisplayString(group.name)
                }, null, 8, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.services, (service, serviceKey) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: serviceKey,
                      href: service.url,
                      class: "flex-initial w-full p-4 hover:bg-gray-100 transition duration-150"
                    }, [
                      _createElementVNode("span", {
                        class: "font-medium text-gray-600",
                        textContent: _toDisplayString(service.name)
                      }, null, 8, _hoisted_5)
                    ], 8, _hoisted_4))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}